import { render, staticRenderFns } from "./helpDetail.vue?vue&type=template&id=2fdd42f1&scoped=true"
import script from "./helpDetail.vue?vue&type=script&lang=js"
export * from "./helpDetail.vue?vue&type=script&lang=js"
import style0 from "./helpDetail.vue?vue&type=style&index=0&id=2fdd42f1&prod&lang=css"
import style1 from "./helpDetail.vue?vue&type=style&index=1&id=2fdd42f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd42f1",
  null
  
)

export default component.exports